// mui
import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardHeader,
  Chip,
  Typography,
} from '@mui/material';

// helpers
import { getInitials } from '@karehero/helpers/name';

export interface CareCircleMemberCardProps {
  /** Their name, or the email an invite went to. */
  name: string;
  /** Their role in the circle, or their relationship to the recipient. */
  role?: string;
  email?: string;
  avatarSrc?: string;
  /** Invited but not yet joined. */
  isInvited?: boolean;
  onRemove?: () => void;
  onResendInvite?: () => void;
}

/** CareCircleMemberCard shows one person in a care circle. */
export const CareCircleMemberCard = ({
  name,
  role,
  email,
  avatarSrc,
  isInvited = false,
  onRemove,
  onResendInvite,
}: CareCircleMemberCardProps) => (
  <Card elevation={0}>
    <CardHeader
      avatar={
        <Avatar alt={name} src={avatarSrc}>
          {getInitials(name)}
        </Avatar>
      }
      title={name}
      subheader={
        <>
          {role}
          {email && (
            <Typography variant='body2' color='text.secondary'>
              {email}
            </Typography>
          )}
        </>
      }
      action={
        isInvited && (
          <Chip
            label='Invited'
            size='small'
            color='primary'
            variant='outlined'
          />
        )
      }
      slotProps={{
        content: { sx: { minWidth: 0 } },
        action: { sx: { alignSelf: 'center', m: 0 } },
        title: { noWrap: true },
      }}
    />
    {(onRemove || onResendInvite) && (
      <CardActions>
        {onResendInvite && (
          <Button size='small' onClick={onResendInvite}>
            Resend Invite
          </Button>
        )}
        {onRemove && (
          <Button size='small' color='error' onClick={onRemove}>
            {/* Only an invite can be resent, so that is what is being removed. */}
            {onResendInvite ? 'Remove Invite' : 'Remove'}
          </Button>
        )}
      </CardActions>
    )}
  </Card>
);

CareCircleMemberCard.displayName = 'CareCircleMemberCard';
export default CareCircleMemberCard;
